import styles from "./addProductWizard.module.scss";
import { getSelectStyles } from "../../../utils";
import Select, { components } from "react-select";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectProductMethod,
  selectRecipeOptions,
  selectSelectedProduct,
  setFormData,
  setSelectedStage,
} from "./AddProductWizardSlice";
import { sdStates } from "../../sharedData/sharedDataSlice";
import { FaInfoCircle } from "react-icons/fa";
import { productApi } from "../../../api/productApi";
import { CgAsterisk } from "react-icons/cg";
import sharedDataApi from "../../../api/sharedDataApi";


export const fieldTypeOptions = Object.freeze({
  text: "text",
  dropdown: "dropdown",
  number: "number",
});

const AddProductForm = ({ setFormErrorsExist }) => {
  const dispatch = useDispatch();
  const latestValidationId = useRef(0);
  const modelRegex = /^[A-Za-z0-9-]{7,20}$/;

  const productData = useSelector(selectSelectedProduct);
  // const [currValues, setData] = useState(productData || {});

  // Ensure ModelNumber is set to null when initializing the form, making it explicitly empty.
  const [currValues, setData] = useState({
    ...productData,
    ModelNumber: null, // Explicitly set ModelNumber to null
  });

  const [validationsErrors, setValidationErrors] = useState({});
  const searchTimeoutId = useRef(null);

  const recipeOptions = useSelector(selectRecipeOptions);
  const [availableClonableStates, setAvailableClonableStates] = useState([]);
  const [currentlySelectedStage, setCurrentlySelectedStage] = useState(null);
  const [formErrors, setFormErrors] = useState({
    ModelNumber: {
      isValid: true,
      errorText: "",
    },
    Family: {
      isValid: true,
      errorText: "",
    },
    Category: {
      isValid: true,
      errorText: "",
    },
    SubCategory: {
      isValid: true,
      errorText: "",
    },
    BtEnabled: {
      isValid: true,
      errorText: "",
    },
    ControlId: {
      isValid: true,
      errorText: "",
    },
    ControlType: {
      isValid: true,
      errorText: "",
    },
    SoftwareVersion: {
      isValid: true,
      errorText: "",
    },
    ShareddataVersion: {
      isValid: true,
      errorText: "",
    },
    Recipe: {
      isValid: true,
      errorText: "",
    },
  });
  const selectedMethod = useSelector(selectProductMethod);

  const [fields, setFields] = useState({
    ModelNumber: {
      label: "Model Number",
      placeholder: "Enter product number",
      fieldType: fieldTypeOptions.text,
      required: true,
      readOnly: false,
    },
    Family: {
      label: "Product Family",
      placeholder: "Enter product family",
      fieldType: fieldTypeOptions.text,
      required: true,
      readOnly: false,
    },
    Category: {
      label: "Product Category",
      placeholder: "Enter product category",
      fieldType: fieldTypeOptions.text,
      required: true,
      readOnly: false,
    },
    SubCategory: {
      label: "Product Subcategory",
      placeholder: "Enter product subcategory",
      fieldType: fieldTypeOptions.text,
      required: true,
      readOnly: false,
    },
    BtEnabled: {
      label: " Bluetooth Enabled",
      placeholder: "Enter Bluetooth Enabled",
      fieldType: fieldTypeOptions.dropdown,
      required: true,
      readOnly: false,
      values: [
        {
          value: true,
          label: "Yes",
        },
        {
          value: false,
          label: "No",
        },
      ],
    },
    ControlId: {
      label: "Control ID",
      placeholder: "Enter control ID",
      fieldType: fieldTypeOptions.number,
      required: true,
      readOnly: false,
    },
    ControlType: {
      label: "Control Type",
      placeholder: "Enter control type",
      fieldType: fieldTypeOptions.number,
      required: true,
      readOnly: false,
    },
    SoftwareVersion: {
      label: "Software Version",
      placeholder: "Enter software version",
      fieldType: fieldTypeOptions.number,
      required: true,
      readOnly: false,
    },
    ShareddataVersion: {
      label: "Shared Data Version",
      placeholder: "Enter shared data version",
      fieldType: fieldTypeOptions.number,
      required: true,
      readOnly: false,
    },
    Recipe: {
      label: "Shared Data Recipe",
      placeholder: "Select shared data recipe",
      fieldType: fieldTypeOptions.dropdown,
      required: true,
      readOnly: selectedMethod === "copyFromExisting",
      values: recipeOptions,
    },
  });

  const validationErrors = {};

  // Prevent number input auto-increment/decrement on scroll
  useEffect(() => {
    const handleNumberInputWheel = (e) => {
      const target = e.target;
      const activeElement = document.activeElement;
      
      if (target && target.type === 'number' && target === activeElement) {
        target.blur();
        setTimeout(() => {
          target.focus();
        }, 0);
      }
    };

    document.addEventListener('wheel', handleNumberInputWheel, { passive: false, capture: false });

    return () => {
      document.removeEventListener('wheel', handleNumberInputWheel, { passive: false, capture: false });
    };
  }, []);

  // useEffect(() => {
  //   if (currValues !== null) {
  //     dispatch(setFormData(currValues));
  //   }
  // }, [currValues]);

  useEffect(() => {
    const determineStage = () => {
      // if (currValues?.StagingVersion && currValues.StagingVersion !== 0) {
      //   return sdStates.staging;
      // } else if (currValues?.ProductionVersion && currValues.ProductionVersion !== 0) {
      //   return sdStates.production;
      // } else {
      //   return sdStates.draft;
      // }
      if (currValues?.State === "Staging") {
        return sdStates.staging;
      } else if (currValues?.State === "Production") {
        return sdStates.production;
      }
    };

    const selectedStage = determineStage();
    setCurrentlySelectedStage(selectedStage);
    dispatch(setSelectedStage(selectedStage));
  }, [currValues]);

  useEffect(() => {
    const clonableStates = [];
    if (currValues !== null) {
      if (currValues.StagingVersion && currValues.StagingVersion !== 0) {
        clonableStates.push(sdStates.staging);
      }
      if (currValues.ProductionVersion && currValues.ProductionVersion !== 0) {
        clonableStates.push(sdStates.production);
      }
      if (currValues.length === 0) {
        clonableStates.push(sdStates.draft);
      }
    }
    setAvailableClonableStates(clonableStates);
    dispatch(setFormData(currValues));
    
  }, [currValues]);


  useEffect(() => {
    dispatch(setSelectedStage(null));
  }, []);
  const onCloneFromStageChange = (e) => {
    setCurrentlySelectedStage(e.currentTarget.value);
    dispatch(setSelectedStage(e.currentTarget.value));
  };

  useEffect(() => {
  const hasError = Object.values(formErrors).some(
    (field) => !field.isValid
  );

  if (setFormErrorsExist) {
    setFormErrorsExist(hasError);
  }
}, [formErrors]);

  const updateReadOnlyFields = (formFields, readOnlyFields) => {
    readOnlyFields.forEach((field) => {
      formFields[field].readOnly = true;
    });
  };

  const getTrimmedValues = (data, formFields) => {
    const trimmedFormInputValues = {};
    Object.keys(formFields).forEach((fieldName) => {
      if (data.hasOwnProperty(fieldName)) {
        if (formFields[fieldName].fieldType === fieldTypeOptions.text) {
          trimmedFormInputValues[fieldName] = data[fieldName].trim();
        } else {
          trimmedFormInputValues[fieldName] = data[fieldName];
        }
      }
    });
    return trimmedFormInputValues;
  };

  const validateFormAndGetIsValidated = (data) => {
    const updatedValidationMap = {};
    Object.keys(fields).forEach(async (fieldName) => {
      if (
        (!data.hasOwnProperty(fieldName) || data[fieldName] === "") &&
        fields[fieldName].required
      ) {
        updatedValidationMap[fieldName] = {
          isValid: false,
          errorText: `${fields[fieldName].label} field cannot be empty!`,
        };
      } else if (
        fields[fieldName].fieldType === fieldTypeOptions.number &&
        (data[fieldName] < 0 || data[fieldName] > 1000)
      ) {
        updatedValidationMap[fieldName] = {
          isValid: false,
          errorText: `${fields[fieldName].label} must be between 0 and 1000.`,
        };
      } else {
        updatedValidationMap[fieldName] = {
          isValid: true,
          errorText: ``,
        };
      }
      if (fieldName === "ModelNumber") {
        await validateModelNumber();
      }
    });
    setFormErrors((prev) => ({
      ...prev,
      ...updatedValidationMap,
    }));

    return Object.keys(updatedValidationMap).length === 0;
  };

  const validateModelNumber = async (modelNumber) => {
    if (!modelRegex.test(modelNumber)) {
       return {
         isValid: false,
         error: "Invalid model number format.",
       };
     }
     
    try {
        // Use Elasticsearch filter with exact match (keyword field)
        const response = await productApi.searchProducts({
          filter: {
            ModelNumber: {
              eq: modelNumber, // Use 'eq' for exact match
            },
          },
          limit: 1, // We only need to know if at least one exists
        });
  
      // Check if any result matches case-insensitively
      const hasMatch = response.items.some(
        item => item.ModelNumber?.toLowerCase() === modelNumber.toLowerCase()
      );

      if (hasMatch) {
        throw new Error("The product with this model number already exists. Please use different model number.");
      }
 
      // Try OpenSearch first
      let actionItems = [];
 
      const searchResult = await sharedDataApi.searchActionItems({
        filter: { ModelNumber: { eq: modelNumber } },
        limit: 1,
      });
 
      console.log(
        "[validateModelNumber] OpenSearch response:",
        JSON.stringify(searchResult, null, 2)
      );
 
      if (searchResult?.items) {
        actionItems = searchResult.items;
      }
 
      // If OpenSearch returned nothing, fallback to DynamoDB with pagination
      if (actionItems.length === 0) {
        console.log(
          "[validateModelNumber] OpenSearch returned 0 items, trying DynamoDB listActionItems with pagination..."
        );
 
        let nextToken = null;
        let found = false;
        const maxPages = 10; // Safety limit to prevent infinite loops
        let pageCount = 0;
 
        do {
          pageCount++;
          const listResult = await sharedDataApi.listActionItems({
            filter: { ModelNumber: { eq: modelNumber } },
            limit: 100,
            nextToken: nextToken,
          });
 
          console.log(
            `[validateModelNumber] DynamoDB page ${pageCount} response:`,
            JSON.stringify({
              itemCount: listResult?.items?.length,
              hasNextToken: !!listResult?.nextToken,
            })
          );
 
          if (listResult?.items && listResult.items.length > 0) {
            // Check if any item matches
            const matchingItem = listResult.items.find(
              (item) => item.ModelNumber?.toLowerCase() === modelNumber.toLowerCase()
            );
 
            if (matchingItem) {
              actionItems = [matchingItem];
            found = true;
            break;
          }
        }
 
        nextToken = listResult?.nextToken;
      } while (nextToken && !found && pageCount < maxPages);
 
      if (!found && nextToken) {
        console.warn(
          "[validateModelNumber] Reached max pages without finding item or exhausting results"
        );
      }
    }
 
    // Check for matching model number (case-insensitive)
    const hasActionMatch = actionItems.some(
      (item) => item.ModelNumber?.toLowerCase() === modelNumber.toLowerCase()
    );
 
    console.log(
      "[validateModelNumber] Found actionItems:",
      actionItems.length,
      "hasActionMatch:",
      hasActionMatch
    );
 
    if (hasActionMatch) {
      throw new Error(  
        "The product with this model number has been marked as rejected. Please use different model number."
      );
    }
 
      return { isValid: true, error: null };
    } catch (error) {
      console.error("Error validating model number:", error);
      return { isValid: false, error: error.message };
    }
  };
  

  const onFieldChange = async (field, value) => {
    setData((prevState) => ({ ...prevState, [field.key]: value }));
    const updatedValidationMap = { ...formErrors };

    // General field validation
    if (value === "" && field.required) {
      updatedValidationMap[field.key] = {
        isValid: false,
        errorText: `${field.label} field cannot be empty!`,
      };
    } else if (
      field.fieldType === fieldTypeOptions.number &&
      (isNaN(value) || value < 0 || value > 1000)
    ) {
      updatedValidationMap[field.key] = {
        isValid: false,
        errorText: `${field.label} must be between 0 and 1000.`,
      };
    } else {
      updatedValidationMap[field.key] = {
        isValid: true,
        errorText: "",
      };
    }
    if (field.key === "ModelNumber") {
      // clear debounce
      if (searchTimeoutId.current) {
        clearTimeout(searchTimeoutId.current);
      }

      // cancel any pending async validation
      latestValidationId.current++;

      // REGEX validation (replaces underscore + length checks)
      if (!modelRegex.test(value)) {
        setFormErrors((prev) => ({
          ...prev,
          ModelNumber: {
            isValid: false,
            errorText:
              "Model must be 7–20 characters and can contain only letters, numbers, and hyphen (-).",
          },
        }));
        // return;
      } else {

      // API validation (only if regex passes)
      const validationId = ++latestValidationId.current;

      searchTimeoutId.current = setTimeout(async () => {
        const { isValid, error } = await validateModelNumber(value);

        if (validationId !== latestValidationId.current) return;

        setFormErrors((prev) => ({
          ...prev,
          ModelNumber: {
            isValid,
            errorText: error || "",
          },
        }));
      }, 500);
    }
    } else {
      // If it's not ModelNumber, update form errors immediately
      setFormErrors((prev) => ({
        ...prev,
        ...updatedValidationMap,
      }));

    }

    // Update data state
    // setData((prevState) => ({ ...prevState, [field.key]: value }));
  };

  const valuesArray = Object.keys(fields).reduce(
    (acc, curr, index) => (
      index % 2 === 0 ? acc.push([curr]) : acc[acc.length - 1].push(curr), acc
    ),
    []
  );

  const getDefaultValue = (key) => {
    return fields[key].values.find(({ value, label }) => {
      if (typeof value === "object") {
        return label === currValues[key];
      }
      return value === currValues[key];
    });
  };
  const customInput = (props) => {
    return (
      <components.Input
        {...props}
        style={{
          ...props.getStyles("input", props),
          textAlign: "left",
          direction: "ltr",
          background: "transparent",
          padding: "0",
          margin: "0",
          border: "none",
          font: "inherit",
        }}
      />
    );
  };

  const isAllowedKey = (key) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
    return /^\d$/.test(key) || allowedKeys.includes(key);
  };

  useEffect(() => {
  if (recipeOptions?.length > 0) {
    setFields((prevFields) => ({
      ...prevFields,
      Recipe: {
        ...prevFields.Recipe,
        values: recipeOptions,
        readOnly: selectedMethod === "copyFromExisting",
      },
    }));
  }
}, [recipeOptions, selectedMethod]);


  const unicodeWhitespaceRegex = /^[\s\u00A0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]+/;
  const handleBeforeInput = (e) => {
    if (e.inputType === "insertText" || e.inputType === "insertFromPaste") {
      const inputValue = e.data || (e.clipboardData && e.clipboardData.getData("text"));
      const currValue = e.target.value;
      if ((currValue.length === 0 && inputValue && unicodeWhitespaceRegex.test(inputValue)) ||
          (inputValue && unicodeWhitespaceRegex.test(inputValue))) {
        e.preventDefault();
      }
    }
  };
  const handleBlur = (e, key) => {
    if (fields[key].fieldType === fieldTypeOptions.text) {
      const trimmed = e.target.value.replace(unicodeWhitespaceRegex, "");
      if (trimmed !== e.target.value) {
        setData((prevState) => ({ ...prevState, [key]: trimmed }));
      }
    }
  };

  return (
    <table className={styles.body}>
      <tbody>
        {valuesArray.map((keysArray) => (
          <tr key={keysArray} className={styles.tr}>
            {keysArray.map((key) => {
              if (fields[key].fieldType !== fieldTypeOptions.dropdown) {
                const isString = fields[key].fieldType === fieldTypeOptions.text;
                const hasLeadingSpace = isString && currValues && typeof currValues[key] === 'string' && unicodeWhitespaceRegex.test(currValues[key]);
                return (
                  <td key={key} className={styles.td}>
                    <label>
                      {fields[key].label}
                      {fields[key].required && "*"}
                    </label>
                    <input
                      className={fields[key].readOnly && styles.readOnlyField}
                      disabled={fields[key].readOnly}
                      type={fields[key].fieldType}
                      value={currValues && currValues[key]}
                      maxLength={key === "ModelNumber" ? 18 : undefined}
                      onChange={(e) => {
                        onFieldChange({ ...fields[key], key }, e.target.value);
                      }}
                      onBeforeInput={isString ? handleBeforeInput : undefined}
                      onBlur={isString ? (e) => handleBlur(e, key) : undefined}
                      onKeyDown={(e) => {
                        if (fields[key].fieldType === fieldTypeOptions.number && !isAllowedKey(e.key)) {
                          e.preventDefault();
                          const fieldKey = key;
                          const fieldLabel = fields[key].label;
                          
                          setFormErrors((prev) => ({
                            ...prev,
                            [key]: {
                              isValid: false,
                              errorText: `${fieldLabel} accepts numbers only.`,
                            },
                          }));
                          // Auto-clear error after 2 seconds
                          setTimeout(() => {
                            setFormErrors((prev) => {
                              if (prev[fieldKey]?.errorText === `${fieldLabel} accepts numbers only.`) {
                                return {
                                  ...prev,
                                  [fieldKey]: {
                                    isValid: true,
                                    errorText: "",
                                  },
                                };
                              }
                              return prev;
                            });
                          }, 2000);
                        }
                      }}
                      placeholder={fields[key].placeholder}
                      pattern={isString ? "^\\S.*$" : undefined}
                      title={isString ? "First character cannot be a space" : undefined}
                      aria-invalid={hasLeadingSpace || (formErrors[key] && !formErrors[key].isValid) ? "true" : undefined}
                      aria-describedby={hasLeadingSpace ? `${key}-whitespace-error` : undefined}
                    />
                    <p className={styles.errorText} id={hasLeadingSpace ? `${key}-whitespace-error` : undefined}>
                      {hasLeadingSpace ? "First character cannot be a space." : (formErrors[key] && formErrors[key].errorText)}
                    </p>
                  </td>
                );
              }
              if (fields[key].fieldType === fieldTypeOptions.dropdown) {
                return (
                  <td key={key} className={styles.td}>
                    <label>
                      {fields[key].label}
                      {fields[key].required && "* "}
                      {key === "Recipe" && (
                        <span
                          className={styles.infoIcon}
                          title="Please contact the developer if you need to add more recipes."
                        >
                          <FaInfoCircle />
                        </span>
                      )}
                    </label>
                    <Select
                      components={{ Input: customInput }} // Override the default input component
                      isDisabled={fields[key].readOnly}
                      placeholder={fields[key].placeholder}
                      defaultValue={getDefaultValue(key)}
                      onChange={(selection) => {
                        const { label, value } = selection;
                        onFieldChange({ ...fields[key], key }, label);
                        setData((prevState) => {
                          return { ...prevState, [key]: value };
                        });
                      }}
                      options={fields[key].values}
                      styles={{
                        ...getSelectStyles(),
                        control: (defaultStyles) => ({
                          ...defaultStyles,
                          overflow: "hidden",
                          fontFamily: "UniversLTStd-Light",
                          width: "100%",
                          fontSize: ".82rem",
                          borderCollapse: "separate",
                          height: "2.9rem",
                          outline: "none",
                          borderRadius: ".5rem",
                          margin: "0.5rem 0 1rem 0",
                        }),
                        placeholder: (defaultStyles) => ({
                          ...defaultStyles,
                          fontSize: ".82rem",
                        }),
                      }}
                    />
                    <p className={styles.errorText}>
                      {formErrors[key] && formErrors[key].errorText}
                    </p>
                  </td>
                );
              }
            })}
          </tr>
        ))}
        <div className={styles.stateMessage}>
          <span><CgAsterisk />The product will be created in the <strong>Staging State</strong>. upon approval by the Reviewer. Once it is approved and moved to production, it will enter the <strong>Production State</strong>. </span>
        </div>
      </tbody>
    </table>
  );
};

export default AddProductForm;
